import { WorkOrderField } from '@atom/types/work';

import classes from './workOrderFields.module.css';

interface Props {
  field: WorkOrderField;
}

const WorkOrderSummary = ({ field }: Props) => {
  return (
    <div className={classes.fieldSummary}>
      <div className={classes.fieldSummaryTitle}>{field.title}</div>
      <div className={classes.fieldSummaryValue}>{field.value}</div>
    </div>
  );
};

export default WorkOrderSummary;
